module.exports = __webpack_public_path__ + "img/Predictor_thumb.de4e1cb2.png";